@if (show) {
  <div class="login-status-message with-margin-top with-margin-bottom">
    <spen-flash-message>
      <div class="message">{{ message }}</div>
      @if (showLink) {
        <div class="link">
          <a spenLink href="{{ link }}" target="_blank">{{ link }}</a>
        </div>
      }
    </spen-flash-message>
  </div>
}
